import React from 'react';
import { useTranslation } from 'react-i18next';
import LeftArrowIcon from '@/lib/assets/leftArrow.svg';
import styles from '@/lib/components/BackLink/BackLink.module.scss';

const BackLink = ({callBackUrl}) => {
    const { t } = useTranslation();
    return (
        <>
            <div className={styles.paymentPlanBackLink} onClick={() => {
                if (callBackUrl) {
                    window.location.assign(callBackUrl);
                } else {
                    window.history.back();
                }
            }}>
                <span className={styles.leftArrowIcon}>
                    <LeftArrowIcon />
                </span>
                <p>
                    {t('returnToPaymentMethod')}
                </p>
            </div>
            <div className={styles.paymentPlanHeader}>{t('paymentPlan')}</div>
        </>
    );
};

export default BackLink;
